import React from "react";
import { RichTextEditorTemplate } from "themes/common/components";

function RichTextEditor(props) {
    return <RichTextEditorTemplate {...props} />;
}

export default RichTextEditor;
